// extracted by mini-css-extract-plugin
export var fulfillmentPanel = "_g7-0";
export var fulfillmentPanelBody = "_g7-1";